<!--
  ~ Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
  -->

<ng-content />
